export default "__VITE_ASSET__BtP54ccY__"